// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DomEl$GameDataCore from "../DomEl.res.mjs";

function mounted() {
  var self = this ;
  self.scrollLeft = 0;
  self.scrollTop = 0;
  var element = self.el;
  DomEl$GameDataCore.on(element, "scroll", (function (_event) {
          self.scrollLeft = element.scrollLeft;
          self.scrollTop = element.scrollTop;
        }));
}

function beforeUpdate() {
  var self = this ;
  var element = self.el;
  self.scrollLeft = element.scrollLeft;
  self.scrollTop = element.scrollTop;
}

function updated() {
  var self = this ;
  var element = self.el;
  element.scrollLeft = self.scrollLeft;
  element.scrollTop = self.scrollTop;
}

var preserveScroll = {
  mounted: mounted,
  beforeUpdate: beforeUpdate,
  updated: updated
};

export {
  mounted ,
  beforeUpdate ,
  updated ,
  preserveScroll ,
}
/* mounted Not a pure module */
